export default __webpack_public_path__ + "static/media/demonic-foliage--240.38b9f108.jpg";